import styled from 'styled-components';
import { fonts, colors, sizes } from 'stylesheets';
import icon from 'assets/img/icon.png';
import dropdown from 'assets/img/arrow.png';

export const HeaderStyled = styled.div`
  width: 100%;
  height: ${sizes.headerLaptop}px;
  background: ${colors.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  position: fixed;
  z-index: 3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button {
    border: none !important;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    transition: box-shadow 0.2s;
    img {
      width: 16px;
      height: 16px;
    }
    span {
      font-size: 11px;
    }
    &:hover {
      box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.25);
      transition: box-shadow 0.2s;
    }
  }
`;

export const Logo = styled.div`
  width: ${sizes.headerLaptop}px;
  height: ${sizes.headerLaptop}px;
  background: url(${icon}) no-repeat center;
  background-size: cover;
`;

export const Right = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CompanyLogo = styled.div`
  width: 100px;
  height: 60px;
  background: url(${props => props.src}) no-repeat center;
  background-size: contain;
  margin: 0px 0px 0px 35px;
`;

export const UserDropdown = styled.div`
  width: 240px;
  height: 65px;
  border-left: 1px solid ${colors.greyLighter};
  display: flex;
  align-items: center;
  position: relative;
  margin-left: 35px;
  &:hover {
    cursor: pointer;
    background: ${colors.blueLight};
  }
  &:after {
    content: "";
    width: 7px;
    height: 5px;
    position: absolute;
    right: 50px;
    top: 32.5px;
    background: url(${dropdown})no-repeat center;
    background-size: contain;
  }
`;

export const UserPhoto = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  margin: 0px 15px;
  background: url(${props => props.src}) no-repeat center;
  background-size: contain;
`;

export const UserName = styled.span`
  font: 15px ${fonts.secondary};
  color: ${colors.greyDark};
`;

export const DropDownOptions = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  width: 239px;
  max-height: 140px;
  background: ${colors.white};
  margin-top: 8px;
  position: fixed;
  right: 0px;
  top: 58px;
  box-shadow: 0 2px 4px rgba(0,0,0,.25);
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  z-index: 5;
`;

export const HeaderOptions = styled.div`
  width: 100%;
  height: 50px;
  background: ${colors.blueLight};
  border-bottom: 1px solid #95b8f9;
  padding: 5px 10px;
`;

export const Name = styled.p`
  font: 500 12px ${fonts.secondary};
  margin-bottom: 5px;
  color: ${colors.greyDark};
`;

export const Email = styled.p`
  font: 400 12px ${fonts.secondary};
  margin: 0px;
  color: #7f7f7f;
`;

export const List = styled.ul`
  width: 100%;
  padding: 0px;
`;

export const Item = styled.li`
  list-style: none;
  display: block;
  padding-left: 10px;
  font: 400 12px ${fonts.secondary};
  color: ${colors.greyDark};
  height: 30px;
  line-height: 30px;
  &:hover {
    background: hsla(0,0%,77%,.2);
    cursor: pointer;
  }
`;
